Namespace.create('cv.Views.Setup').ShareView = Marionette.LayoutView.extend({
  className : 'view-setup-share',

  template: cv.Templates['setup/share/view'],

  events : {
    'click .form-save' : 'toDashboard'
  },

  validation: {
  },

  templateHelpers: function(){
    return {
      url : this.model.get('url')
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(this.model, 'sync', function(){
      this.$('.form-save').removeClass('button-disabled');
    }, this);

    console.log('SetupShareView initialized.');
  },

  toDashboard: function(e){
    e.preventDefault();

    top.location = '/' + this.model.get('stub') + '/admin/dashboard';
  },

  onShow: function(){
    // Re-render the screen
    this.model.fetch({
      reset: true,
      success: _.bind(function(){
        this.render();
      }, this)
    });

    // Change document title
    document.title = 'Setup | Spread the Word';
  },
});
